<router-outlet></router-outlet>
<ngx-spinner size = "medium"  [fullScreen] = "true" template = "<img src='/assets/loader.gif'/>"></ngx-spinner>
